import React from "react";
import { Field, ErrorMessage } from "formik";
import styles from "./checkbox.module.scss";
import ErrorText from "components/shared/errortext/ErrorText";

const Checkbox = (props) => {
  const { label, name, isRequired, ...rest } = props;

  return (
    <div className={styles.checkboxControl}>
      <Field name={name} type="checkbox">
        {({ field }) => (
          <div className={styles.checkboxWrapper}>
            <input
              {...field}
              {...rest}
              id={name}
              type="checkbox"
              className={styles.checkboxInput}
            />
            <label className={styles.label} htmlFor={name}>
              {label}
              {isRequired && <span className={styles.requiredMark}>*</span>}
            </label>
          </div>
        )}
      </Field>
      <ErrorMessage name={name} component={ErrorText} />
    </div>
  );
};

export default Checkbox;
